import Button from "@components/ui/button";
import Icon from "@components/ui/icon";
import { cn } from "@lib/cn";
import { MediaLibFilesSkeleton } from "./files/media-lib-files-skeleton";

interface IProps {
  className?: string;
  onReload?: () => void;
}

export const MediaLibError = ({ onReload, className }: IProps) => {
  return (
    <div
      className={cn(
        "tw-relative tw-mt-6 tw-flex tw-h-full tw-flex-col tw-items-center tw-overflow-hidden tw-text-center",
        className,
      )}
    >
      <div className="tw-z-1 tw-mt-32">
        <Icon
          icon="ri-error-warning-fill"
          className="tw-text-[24px]/none tw-text-red-base"
        />
        <div className="tw-text-md tw-mb-4 tw-mt-1 tw-font-medium">
          Failed to load, please try again
        </div>

        {onReload && (
          <Button variant="secondary" size="sm" onClick={onReload}>
            <Icon icon="ri-refresh-line" className="tw-mr-1.5" />
            Reload
          </Button>
        )}
      </div>

      <div className="tw-absolute tw-left-0 tw-top-0 tw-w-full tw-opacity-60">
        <MediaLibFilesSkeleton noAnim />
      </div>
    </div>
  );
};
